import {HttpModelConverter} from '../../../core/converter/httpModel.converter';
import {AccountSummary} from '../../../../shared/model/account/accountSummary.model';
import {CountryConverter} from '../../../common/localization/country/api/entity/converter/country.converter';
import {Injectable} from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class AccountSummaryConverter extends HttpModelConverter<AccountSummary> {

    protected createInstance(): AccountSummary {
        return new AccountSummary();
    }

    protected enrichObject(result: AccountSummary, src: AccountSummary) {
        result.country = new CountryConverter().convert(src.country);
    }


}